import { Flex, Text } from "@chakra-ui/react";
import { H1 } from "components/text/headings";

/**
 * A title, subtitle header for a page. Use this for consistent colours, layout, and font
 *
 * superTitle: a small lime-green title above the title
 * e.g. see AI Review https://www.figma.com/design/uDql1qJTNBIvGnFDsOpWV4/ESG360-AIR?node-id=3363-86489&t=p2LRUjnF9emyYCTc-1
 */
export default function PageHeader({
  title,
  subTitle,
  superTitle,
  icon,
  titleSize = "heading.3xl",
  superTitleSize = "body.m",
  subTitleSize = "body.m",
}) {
  return (
    <Flex direction="column" gap={2}>
      {superTitle && (
        <Text color="limeShade.600" fontSize="body.m" mb={4}>
          {superTitle}
        </Text>
      )}
      <H1 display="flex" alignItems="center" gap={2} fontSize={titleSize}>
        {icon}
        {title}
      </H1>
      {subTitle && (
        <Text color="gray.500" fontSize="body.m">
          {subTitle}
        </Text>
      )}
    </Flex>
  );
}
